// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../components/smart-table/smart-table.model';

/** @ngInject */
export function Controller(
    $scope,
    $state,
    Account,
    GoogleSharedService,
) {
    $scope.samlImage = window.env.urls.samlAppLogo('google-apps');
   
   
    $scope.displaySpinner = false;
    $scope.companyApplicationDto = [];
    $scope.st = new SmartTable();
    
    $scope.entityName = '';
    
    $scope.newCompanyName;
    
    $scope.displayApplicationStep = false;
    
    $scope.company;
    
    $scope.googleAppsApplicationType;

    
    $scope.displayCreateCompany = false;
    
    $scope.selectedCompany = 0;
    
    $scope.showEmailChangeOwner = false;
    
    $scope.displayErrorEmailChange = false;
    $scope.showChangeEmailOwnerNoDomain = false;
    $scope.emailBelongToUser = false;
    $scope.emailExistsInSystem = false;
    $scope.domainVerified = false;
    $scope.userIsAdminOfDomainInSaaspass = false;
    $scope.userisAdminInSaaspass = false;
    $scope.companiesOfUser = [];

    Account.get().then((account) => {
        if (account.userEmailAddress) {
            $scope.emailAddress = account.userEmailAddress;
            $scope.domain = account.userEmailAddress.split('@')[1];
            $scope.executeInitPage();
        }
    });

    $scope.userIsAdminOfDomainInSaaspass = false;
    
    $scope.executeInitPage = function(){
        if($scope.domain && $scope.emailAddress){
            
            $scope.domainVerified = false;
            
            $scope.emailBelongToAnotherUser = false;
            
            $scope.showGoogleAppsForAdmin = true;
            
            GoogleSharedService.getGoogleAppsInfo.get({
                emailAddress:$scope.emailAddress,
                domainName:$scope.domain
            }, function(data) {
                $scope.domainVerified = data.domainVerified;
                $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
                $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
                $scope.companyApplicationDto = data.googleAppsInCompany;
                $scope.company = data.domainOwnerCompany;
                $scope.googleAppsApplicationType = data.googleAppsApplicationType;
                $scope.emailBelongToUser = data.emailBelongToUser;
                $scope.emailExistsInSystem = data.emailExistsInSystem;
                $scope.companiesOfUser = data.companiesOfUser;
                
                $scope.createEmailForUser();
            });
        }
    }
    
    
    
    $scope.createEmailForUser = function(){
        if(!$scope.showErrorOnStart()){
            if(!$scope.emailBelongToUser && !$scope.emailExistsInSystem){
                GoogleSharedService.createUserEmail.get({
                    emailAddress:$scope.emailAddress
                }, function(data) {
                    $scope.domainVerified = data.domainVerified;
                    $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
                    $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
                    $scope.companyApplicationDto = data.googleAppsInCompany;
                    $scope.company = data.domainOwnerCompany;
                    $scope.googleAppsApplicationType = data.googleAppsApplicationType;
                    $scope.emailBelongToUser = data.emailBelongToUser;
                    $scope.emailExistsInSystem = data.emailExistsInSystem;
                    $scope.companiesOfUser = data.companiesOfUser;
                    
                    $scope.createEmailForUser();
                },
                function(error) {
                    console.log(error);
                });
            }else if(!$scope.emailBelongToUser && $scope.emailExistsInSystem && !$scope.domainVerified){
                $scope.showChangeEmailOwnerNoDomain = true;
            }else if($scope.userIsAdminOfDomainInSaaspass){                
                $scope.displayCreateCompany = false;
                $scope.displayApplicationStep = true;
                $scope.showEmailChangeOwner = false;
                $scope.showChangeEmailOwnerNoDomain = false;
            }
        }        
    }
    
    $scope.showErrorOnStart = function(){
        return $scope.domainVerified && !$scope.userIsAdminOfDomainInSaaspass;
    }
    
   
    
    //show createEmailDomain when domain is not verifyed in saaspass and email don't exists in saaspass.
    $scope.showCreateEmail = function(){
        if(!$scope.showErrorOnStart()){
            return !$scope.domainVerified && $scope.emailBelongToUser && $scope.emailExistsInSystem;
        }else{
            return false;
        }
        
    }
    
    $scope.showSelectComapnyOrCreateNew = function(){
        return !$scope.displayCreateCompany && $scope.showCreateEmail() && $scope.userisAdminInSaaspass;
    }
    
    //show create new company form
    $scope.showCreateNewCompany = function(){
        if(!$scope.displayCreateCompany){
            return $scope.showCreateEmail() && !$scope.userisAdminInSaaspass;
        }else{
            return $scope.displayCreateCompany;
        }
    }
    
    //show transfer email when no domain is not veifyed in saaspass for this email and email exists in saaspass but not for this saaspaas user.
    $scope.showTransferEmailNonAdmin = function(){
        if(!$scope.showErrorOnStart()){
            return !$scope.domainVerified && !$scope.emailBelongToUser && $scope.emailExistsInSystem;
        }else{
            return false;
        }
    }
    
    $scope.companySelectionChange = function(selectedCompany){ 
        $scope.selectedCompany = selectedCompany
        if($scope.selectedCompany > 0){
            GoogleSharedService.updateCompanyWithDomain.get({
                domain:$scope.domain,
                email:$scope.emailAddress,
                companyId:$scope.selectedCompany
            }, function(data) {
                $scope.domainVerified = data.domainVerified;
                $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
                $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
                $scope.companyApplicationDto = data.googleAppsInCompany;
                $scope.company = data.domainOwnerCompany;
                $scope.googleAppsApplicationType = data.googleAppsApplicationType;
                $scope.emailBelongToUser = data.emailBelongToUser;
                $scope.emailExistsInSystem = data.emailExistsInSystem;
                $scope.companiesOfUser = data.companiesOfUser;
                
                $scope.createEmailForUser();
            },
            function(error) {
                console.log(error);
            });    
        }
    }
    
    $scope.goToCreateNewCompany = function(){
        $scope.newCompanyName = "";
        $scope.displayCreateCompany = true;
    }
    
    $scope.createCompany = function(newCompanyName){
        $scope.newCompanyName = newCompanyName;
        console.log("New Comapny"+$scope.newCompanyName);
        GoogleSharedService.createCompanyWithDomain.get({            
            email:$scope.emailAddress,
            companyName:$scope.newCompanyName
        }, function(data) {
            $scope.domainVerified = data.domainVerified;
            $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
            $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
            $scope.companyApplicationDto = data.googleAppsInCompany;
            $scope.company = data.domainOwnerCompany;
            $scope.googleAppsApplicationType = data.googleAppsApplicationType;
            $scope.emailBelongToUser = data.emailBelongToUser;
            $scope.emailExistsInSystem = data.emailExistsInSystem;
            $scope.companiesOfUser = data.companiesOfUser;
            
            $scope.redirectToApplicationAfterCreateNewCompany();
        },
        function(error) {
            console.log(error);
        });    
    }
    
    
    $scope.redirectToApplicationAfterCreateNewCompany = function(){
        if($scope.companyApplicationDto && $scope.companyApplicationDto.length > 0){
            var app = $scope.companyApplicationDto[0];
            $scope.manageApplication(app);
        }
    }
    
    $scope.changeOwnerOfEmailYes = function(){        
        GoogleSharedService.updateUserEmailOwner.get({
            email:$scope.emailAddress,
            companyId:$scope.company.id
        }, function(data) {
            $scope.displayApplicationStep = true;
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
            
        },
        function(error) {
            console.log(error);
        });        
    }
    
    $scope.changeOwnerOfEmailNo = function(){
        if($scope.domainVerified){
            $scope.displayApplicationStep = true;
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
        }else{
            //error
        }
        
    }
    
    $scope.changeOwnerOfEmailNoDomainYes = function(){        
        GoogleSharedService.changeUserEmailOwnerNoDomain.get({
            emailAddress:$scope.emailAddress
        }, function(data) {
            $scope.emailBelongToUser = true;
            $scope.emailExistsInSystem = true;            
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
        },
        function(error) {
            console.log(error);
        });        
    }
    
    $scope.changeOwnerOfEmailNoDomainNo = function(){
        if(!$scope.domainVerified){            
            $scope.displayErrorEmailChange = true;
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
        }else{
            //error
        }
        
    }
    
    $scope.manageApplication = function(app) {    
        if(app.hasDomainGrouop){
            const companyId = $scope.company.id;
            const appId = app.application.id;
            $state.go('company.manage-application', {companyId, appId});
        }else{
            GoogleSharedService.updateGoogleApplicationWithDomain.get({
                domainName:$scope.domain,
                appId:app.application.id
            }, function(data) {
                const companyId = $scope.company.id;
                const appId = data.application.id;
                $state.go('company.manage-application', {companyId, appId});
            },
            function(error) {
                console.log(error);
            });
        }
        
    };
    
    $scope.addNewApplication = function() {
        GoogleSharedService.saveGoogleApplication.get({
            domainName:$scope.domain
        }, function(data) {
            const companyId = $scope.company.id;
            const appId = data.application.id;
            $state.go('company.manage-application', {companyId, appId});
        },
        function(error) {
            console.log(error);
        });
               
    };
   
    
    

}



// WEBPACK FOOTER //
// ./src/portal/states/company/google-marketplace-configuration/google-marketplace-configuration.controller.js